import styled from "@emotion/styled";

export const ViewHeader = styled.div<{ textAlign?: string; hasSubtitle?: boolean }>`
  text-align: ${({ textAlign }) => (textAlign ? textAlign : "left")};
  margin-top: 10px;
  margin-bottom: ${(props) => (props.hasSubtitle ? "15px" : "30px")};
  font-size: 28px;
  font-weight: bold;
  color: #ffffff;
`;

export { TransactionHistoryView } from "./history";
export { HomeView } from "./home";
export { LiquidityView } from "./liquidity/LiquidityView";
export { NFTGalleryView } from "./nft";
export { SwapView } from "./swap/SwapView";
